module.exports = __webpack_public_path__ + "img/pagamenti-alertduedate.b1a40ee3.png";